import { Action } from '@ngrx/store';

export const ADVANCED_FILTER_SUCCESS_ACTION = '[Submission] Advanced Filter Success Action';

export class AdvancedFilterSuccessAction implements Action {
  readonly type = ADVANCED_FILTER_SUCCESS_ACTION;
}



// WEBPACK FOOTER //
// ./src/app/submission/store/actions/AdvancedFilterSuccessAction.ts